import { createSlice } from "@reduxjs/toolkit";
import { ModalInfoType } from "type";

interface PayloadType {
  type: string;
  payload: ModalInfoType;
}
const initValues: ModalInfoType = {
  open: false,
  title: "",
  content: "",
  size: 350,
  dataUpdate: null,
  onClose: () => {},
};
export const modalSlice: any = createSlice({
  name: "modalSlice",
  initialState: initValues,
  reducers: {
    setModal: (state, action: PayloadType) => {
      state.open = action.payload.open;
      state.title = action.payload.title;
      state.content = action.payload.content;
      state.size = action.payload.size;
      state.dataUpdate = action.payload.dataUpdate;
      state.onClose = action.payload.onClose;
    },
  },
});
export const { setModal } = modalSlice.actions;
export default modalSlice.reducer;
